import { CalibrationMathError, HeadroomError } from '../test-runtime/northstarMaths';
import { createComputationWorker } from './computationWorkerFactory';

export function createCalibrationComputer() {
  const worker = createComputationWorker();
  let sequence = 0, pending = null, closed = false;
  const fail = message => { const current = pending; pending = null; if (current) { clearTimeout(current.timer); current.reject(new Error(message)); } };
  worker.onmessage = event => {
    if (!pending || event.data?.requestId !== pending.id) return;
    const current = pending; pending = null; clearTimeout(current.timer);
    if (event.data.error) {
      const ErrorType = event.data.error.name === 'CalibrationMathError' ? CalibrationMathError : event.data.error.name === 'HeadroomError' ? HeadroomError : Error;
      current.reject(new ErrorType(event.data.error.message));
    }
    else current.resolve(event.data.result);
  };
  worker.onerror = event => { event.preventDefault?.(); closed = true; worker.terminate(); fail('Calibration calculation worker stopped.'); };
  worker.onmessageerror = () => { closed = true; worker.terminate(); fail('Calibration result could not be read.'); };
  return {
    compute(input) {
      if (closed || pending) return Promise.reject(new Error('Calibration worker is unavailable or already calculating.'));
      return new Promise((resolve, reject) => {
        const id = `northstar-${++sequence}`;
        pending = { id, resolve, reject, timer: setTimeout(() => { closed = true; worker.terminate(); fail('Calibration calculation timed out.'); }, 30000) };
        try { worker.postMessage({ requestId: id, operation: 'build-lut', input }); } catch (error) { fail(error.message); }
      });
    },
    close() { closed = true; worker.terminate(); fail('Calibration calculation cancelled.'); },
  };
}
